module.exports = "/_next/static/images/footer_bg-f2e31254e7d4c4f067aba281db6ebfbf.webp";